module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-selector"
  }, [_c('i'), _vm._v(" "), _c('div', {
    staticClass: "cover",
    on: {
      "click": _vm.isShow
    }
  }), _vm._v(" "), _c('x-input', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": _vm.title,
      "placeholder": "请选择",
      "disabled": _vm.disabled,
      "required": ""
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    ref: "popup",
    attrs: {
      "position": "top",
      "should-scroll-top-on-show": ""
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    ref: "content",
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.options), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.emitValue(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea5bf47e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/baseComponents/MySelector.vue
// module id = 1091
// module chunks = 1